import React from 'react';
import subscriptionApi, { PlanInfo } from '../../services/subscriptionApi';
import { useSubscription } from '../../context/SubscriptionContext';
import './PlanSelector.css';

interface PlanSelectorProps {
  showCurrentPlan?: boolean;
}

const PlanSelector: React.FC<PlanSelectorProps> = ({
  showCurrentPlan = true
}) => {
  const { planName } = useSubscription();
  const plans = subscriptionApi.getPlans();

  const formatPrice = (plan: PlanInfo) => {
    if (plan.price === 0) return 'Gratis';
    return `${plan.price}€/mes`;
  };

  const isCurrentPlan = (plan: PlanInfo) => {
    return planName === plan.name;
  };

  const getFeaturesList = (plan: PlanInfo) => {
    const features = [];

    // Límites
    if (plan.limits.headaches_per_month === -1) {
      features.push('Registros ilimitados');
    } else {
      features.push(`${plan.limits.headaches_per_month} registros/mes`);
    }

    // Features
    if (plan.features.advanced_analytics) {
      features.push('Analíticas avanzadas');
    }

    if (plan.features.export_data) {
      features.push('Exportar datos');
    }

    if (plan.features.priority_support) {
      features.push('Soporte prioritario');
    }

    return features;
  };

  const getPlanIcon = (planName: string) => {
    switch (planName) {
      case 'free': return '🆓';
      case 'premium': return '⭐';
      case 'unlimited': return '💎';
      default: return '📋';
    }
  };

  return (
    <div className="plan-selector">
      <div className="plans-grid">
        {plans.map((plan) => (
          <div
            key={plan.name}
            className={`plan-card ${isCurrentPlan(plan) ? 'current-plan' : ''} ${plan.name === 'premium' ? 'premium-plan' : ''} ${plan.name === 'unlimited' ? 'unlimited-plan' : ''}`}
          >
            <div className="plan-header">
              <span className="plan-icon">{getPlanIcon(plan.name)}</span>
              <h3 className="plan-name">{plan.display_name}</h3>
              <div className="plan-price">{formatPrice(plan)}</div>
              {isCurrentPlan(plan) && showCurrentPlan && (
                <div className="current-plan-badge">Tu Plan Actual</div>
              )}
            </div>

            <div className="plan-features">
              {getFeaturesList(plan).map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="feature-checkmark">✓</span>
                  {feature}
                </div>
              ))}
            </div>

            {isCurrentPlan(plan) ? (
              <div className="plan-status active">Activo</div>
            ) : (
              <div className="plan-status inactive">Contacta al admin</div>
            )}
          </div>
        ))}
      </div>
      <p className="plan-note">
        Para cambiar de plan, contacta con el administrador.
      </p>
    </div>
  );
};

export default PlanSelector;
